import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type VendedorAppMovilAyudaDialogProps = {
  open: boolean;
  onClose: () => void;
};

const VendedorAppMovilAyudaDialog: React.FC<VendedorAppMovilAyudaDialogProps> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle sx={{ pr: 6, position: 'relative' }}>
      Clientes que ve en la app
      <IconButton
        aria-label="Cerrar ayuda de la app móvil"
        onClick={onClose}
        sx={{ position: 'absolute', right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers>
      <Stack spacing={2}>
        <Typography variant="body2" color="text.secondary">
          La app muestra los clientes asociados al vendedor. El vendedor esta asociado a un usuario. Un usuario puede estar asociado a varios vendedores.
        </Typography>
        <Typography variant="body1">
          <strong>Menu Clientes</strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Muestra solo los clientes asignados a este vendedor, siempre. 
        </Typography>
        <Typography variant="body1">
          <strong>Pedido, visita o cobranza</strong>
        </Typography>
        <Typography variant="body2"  color="text.secondary">
        <strong>Parametro MOBILE:CLIENTES_OTROS_VENDEDORES = 1</strong> 
          <br />
          Al seleccionar un cliente, se muestran todos los clientes de todos los vendedores. 
          <br />
        </Typography>
        <Typography variant="body2" color="text.secondary">
        <strong>Parametro MOBILE:CLIENTES_OTROS_VENDEDORES = 0</strong> 
          <br />
        <strong>Un usuario por vendedor</strong>
          <br />
          Al seleccionar un cliente, se muestran solo los clientes del vendedor seleccionado.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>Sin usuario de vendedor</strong>
          <br />
        Si el usuario no está asociado a ningún vendedor, la app
        muestra todos los clientes.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>Mismo usuario en varios vendedores</strong>
          <br />
          Si el mismo usuario está en varios vendedores, se juntan los clientes de todos ellos.
        </Typography>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="contained" sx={{ textTransform: 'none' }}>
        Entendido
      </Button>
    </DialogActions>
  </Dialog>
);

export default VendedorAppMovilAyudaDialog;
